import React, {useState, useLayoutEffect} from 'react';
import './ret.css';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import dayjs from 'dayjs';
import { isMobile } from 'react-device-detect';

const Learns =()=>{
    const jikap = useParams();
    const [pag, setpag] = useState({});
    const [addnum, setaddnum] = useState(1);
    const [single, setsingle] = useState(window.history.state.page == undefined || window.history.state.page == null ? 1 : window.history.state.page);
    const [arum, setarum] = useState(window.history.state.molan == undefined || window.history.state.molan == null ? "allaround" : window.history.state.molan );
  

    useLayoutEffect(()=>{
        const fetch = async()=>{
            const hoakin = await axios.get(`/api/noree?single=${single}&mdash=${isMobile}`).then(kip=>{setpag({large : kip.data.zonche, list : kip.data.yoso})})
            .catch(err=>console.log("페이지네이션 오류"));
        };
        fetch();
       
        document.title = "문턱넘기 - 돌파공모";
        window.scrollTo(0,0);
    },[single]);

    const addnumber=()=>{
        setaddnum(addnum+1);
        setsingle(addnum*10+1);
    };

    const minusnumber=()=>{
        setaddnum(addnum-1);
        setsingle((addnum-1)*10);
    };
    
    const yidong=(cons)=>{
        setsingle(cons);
        const kogaki = document.getElementById("allca");
        kogaki.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    };
    

    return(
        <>
        <p className='sebut' id='allca'>문턱 넘기</p>
        <div className={isMobile ? 'mbtyes' : 'btyes'}>
        {pag?.list?.map((cons,i)=>{
                    const kdk = `/jika/${cons.sun}`; 
                    const dayr = cons.date;  
                  
                    return(
                        <div className={isMobile ? 'mpytes' : 'pytes'}>
                            <Link to={kdk} className={isMobile ? 'ouno mnot' : 'ouno ynot'} state={cons} onClick={()=>{window.history.replaceState({page : single, molan : arum},null,null); 
                        window.history.states = {page : single, molan : arum};}}>
                            <div className='yunjin'><img src={process.env.PUBLIC_URL+`/inda/${cons.img}`} /></div>
                            <p className='urong tiuro'>{cons.title}</p>
                            <p className='urong'>{cons.category}</p>
                            <div className='uesa'>
                            <span className='urona'>{dayjs(dayr).format('YY-MM-DD')}</span>
                            <span className='urona'>HIT {cons.hit}</span>
                            </div>
                            </Link>
                        </div>
                    );
                })}
        </div>
        {isMobile ? 
     <div className='badaku'>
            {addnum >1 && <button onClick={minusnumber} className='yoruni'><img src={process.env.PUBLIC_URL+'/ssleft.png'} className='yulll'/></button>}
            {pag?.large /100 >= addnum ? Array.from({length : 10},(_,i)=>(addnum-1)*10+i+1).map((cons,i)=>{
                return(<button onClick={()=>yidong(cons)} className="aisu">{cons}</button> );}) : Array.from({length : Math.ceil((pag?.large%100)/10)},(_,i)=>(addnum-1)*10+i+1).map((cons,i)=>{
                   
                return(<button onClick={()=>yidong(cons)} className={`aisu ${single == cons ? "yahii" : ""}`}>{cons}</button> );})}
            {pag?.large > addnum*100 && <button onClick={addnumber} className='yoruni'><img src={process.env.PUBLIC_URL+'/ssright.png'} className='yurrr'/></button>}
     </div>
     : 
     <div className='badaku'>
        {addnum >1 && <button onClick={minusnumber} className='yoruni'><img src={process.env.PUBLIC_URL+'/ssleft.png'} className='yulll'/></button>}
        {pag?.large /90 >= addnum ? Array.from({length : 10},(_,i)=>(addnum-1)*10+i+1).map((cons,i)=>{
          return(<button onClick={()=>yidong(cons)} className="aisu">{cons}</button> );}) : Array.from({length : Math.ceil((pag?.large%90)/9)},(_,i)=>(addnum-1)*10+i+1).map((cons,i)=>{
             
              return(<button onClick={()=>yidong(cons)} className={`aisu ${single == cons ? "yahii" : ""}`}>{cons}</button> );})}
        {pag?.large > addnum*90 && <button onClick={addnumber} className='yoruni'><img src={process.env.PUBLIC_URL+'/ssright.png'} className='yurrr'/></button>}
     </div>   
        }
        </>
    )

}

export default Learns;